// home — or. Part of the or i18n bundle; merged by ./index.js

export default {
  mpTopDashboard: 'Daashboordii',
  mpTopRegister: 'Galmaa\u2019i',
  mpSearchCategory: 'Kutaa',
  mpSearchAllCategories: 'Kutaalee Hundaa',
  mpSearchLocation: 'Naannoo',
  mpSearchAllCities: 'Magaalaalee Hundaa',
  mpSearchKeyword: 'Maqaan barbaa taafu?',
  mpSearchBtn: 'Barbaadi',
  mpTapToRead: 'Lakkawuufi Sussiu \u25bc',
  mpProducts: 'nabiyyee',
};
